import { Store } from 'redux';
import { NotFoundError } from '@cian/peperrors/shared';

import { getReviewsRealtorPage, renderReactApp } from './internal';
import { IAppState, IContext } from '../../../shared/store';

export function renderApp(store: Store<IAppState>, context: IContext) {
  const rootElement = document.getElementById('realtor-reviews-frontend');

  if (!rootElement) {
    throw new NotFoundError({
      message: 'Unable to find element #realtor-reviews-frontend',
      domain: 'services#renderApp',
    });
  }

  const reviewsRealtorPage = getReviewsRealtorPage(context);

  renderReactApp({
    app: reviewsRealtorPage,
    store,
    context,
    rootElement,
  });
}
